module.exports = __webpack_public_path__ + "static/img/logo.e41f887.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/onex/logo.svg
// module id = 1003
// module chunks = 30